import axios from "axios";
import Swal from 'sweetalert2';


const sendEmail = async ({
  application_name,
  env_type,
  email_subject,
  message,
  html_message,
  receiver_addresses,
  cc_addresses,
  bcc_addresses,
  attachments,
}) => {
  try {
    const formData = new FormData();
    formData.append("application_name", application_name || "");
    formData.append("env_type", env_type || "");
    formData.append("email_subject", email_subject);
    formData.append("message", message);
    formData.append("html_message", html_message || "");

    if (receiver_addresses && receiver_addresses.length > 0) {
      receiver_addresses.forEach((address) => {
        formData.append("receiver_addresses[]", address);
      });
    }

    if (cc_addresses && cc_addresses.length > 0) {
      cc_addresses.forEach((address) => {
        formData.append("cc_addresses[]", address);
      });
    }

    if (bcc_addresses && bcc_addresses.length > 0) {
      bcc_addresses.forEach((address) => {
        formData.append("bcc_addresses[]", address);
      });
    }

    if (attachments && attachments.length > 0) {
      attachments.forEach((attachment) => {
        formData.append("attachments", attachment);
      });
    }

    const response = await axios.post(
      "https://app-acs-dev-eastus.azurewebsites.net/send_email",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      // Show SweetAlert success popup for email sent
      Swal.fire({
        title: 'Email Sent!',
        text: response.data.message || 'Email sent successfully',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#073D8D',
        timer: 4000,
        timerProgressBar: true,
      });
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error sending email:", error);
    return false;
  }
};

export default sendEmail;
